import {makeAutoObservable} from 'mobx';
import ChatMessage from 'enum/ChatMessage';
import * as Api from '@/utils/api/api';

export class Message  {
    content;
    userType;

    constructor(content, userType) {
        this.content = content;
        this.userType = userType;
    }
}

class ServiceStore {
    show = false;
    message = '';
    messageList = [];

    constructor() {
        makeAutoObservable(this)
    }

    async addMessage({message, userType}) {
        this.messageList.push(new Message(message, userType));
    }

    async sendMessage(message, callback) {
        try {
            this.message = '';

            const {answer} = await Api.askQuestion({question: message});

            this.addMessage({message: answer, userType: ChatMessage.TO});
            if (callback) {
                callback();
            }
        } catch (error) {
        }
    }

    init() {
        this.messageList = [
            new Message('你好，有什么可以帮到你呢?', ChatMessage.TO)
        ];
    }
}

const store = new ServiceStore();

export default store;
